import React from "react";

import AdminSectionShell from "../components/AdminSectionShell";
import ViewGerenciarConfigSistema from "../views/ViewGerenciarConfigSistema";
import { usePermissao } from "../uteis/permissaoAdm/usePermissao";

const GerenciarConfigSistemaVariaveis: React.FC = () => {
  const { isLoading, isValid } = usePermissao("ADM");

  if (isLoading) return <p>Verificando permissão...</p>;
  if (!isValid) return null;

  return (
    <AdminSectionShell backTo="/gerenciarConfigSistema">
      <ViewGerenciarConfigSistema />
    </AdminSectionShell>
  );
};

export default GerenciarConfigSistemaVariaveis;
